import {
  connect,
} from 'react-redux';
import {
  withTranslation,
} from 'react-i18next';

import {
  actions as mainActions,
} from '../../../redux/modules/main';

import RegattaSettingsPageView from './RegattaSettingsPageView';

// Types
import type {
  $State,
} from '../../../redux';
import type {
  $DispatchProps,
  $OwnProps,
  $StateProps,
} from './RegattaSettingsPageView';

const mapStateToProps = ({
  main,
}: $State): $StateProps => ({
  main,
});

const mapDispatchToProps = (dispatchAction): $DispatchProps => ({
  redirect: (params) => dispatchAction(
    mainActions.redirect(params),
  ),
});

const ConnectedComponent = connect<
$StateProps,
$DispatchProps,
$OwnProps,
$State
>(
  mapStateToProps,
  mapDispatchToProps,
)(RegattaSettingsPageView);

const TranslatedComponent = withTranslation()(ConnectedComponent);

const Component = TranslatedComponent;

export default Component;
